import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  templateUrl: './confirm.component.html',
  standalone: false,
})
export class ConfirmComponent {
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {}

  onCancel(): void {
    this.ref.close(false);
  }

  onConfirm(): void {
    this.ref.close(true);
  }
}